import React, { createContext, useContext } from 'react';
export const CARD_PADDINGS = ['sm', 'md'];
const CardContext = createContext(undefined);
export const CardProvider = ({ padding, children }) => (React.createElement(CardContext.Provider, { value: {
        padding,
    } }, children));
export const useCard = () => {
    const context = useContext(CardContext);
    if (context === undefined) {
        throw new Error('useCard must be used within a CardProvider');
    }
    return context;
};
//# sourceMappingURL=CardContext.js.map